export enum GridElementSubType {
  Cable = "Cable",
  OpenSwitch = "OpenSwitch",
  Consumer = "Consumer",
  CustomerConnectionBox = "CustomerConnectionBox",
  Generator = "Generator",
  JunctionBox = "JunctionBox",
  Meter = "Meter",
  SubstationBusbar = "SubstationBusbar",
  Transformer = "Transformer",
  Sleeve = 'Sleeve',
  LvSubstationBusBarOneTrafo = 'LvSubstationBusBarOneTrafo',
  MvSubstationBusBarOneTrafo = 'MvSubstationBusBarOneTrafo',
  LvSubstationBusBarWithoutTrafo = 'LvSubstationBusBarWithoutTrafo',
  MvSubstationBusBarWithoutTrafo = 'MvSubstationBusBarWithoutTrafo',
  MvStationOneTrafo = 'MvStationOneTrafo',
  MvStationWithoutTrafo = 'MvStationWithoutTrafo',
  MvStationMultipleTrafo = 'MvStationMultipleTrafo',
  LvJunctionBox = 'LvJunctionBox',

  //I-51_statistics
  MvJunctionBox = 'MvJunctionBox',
  Statistics = "Statistics",
  ControllableDevice = "ControllableDevice",

  //Planning Scenario "Load"
  Scenario = "Scenario",

  //Voltag Regulator
  VoltageRegulator = "VoltageRegulator"
}
